import { useEffect, useRef } from "react";
import { useAsyncDebounce } from "react-table";
import useCustomPagination from "../hooks/useCustomPagination";

function CommonPagination({
  totalItems,
  initialItemsPerPage,
  initialPage,
  handleGetDataPageSize,
  handleGetNewPage,
}) {
  const {
    currentPage,
    // startIndex,
    // endIndex,
    setNextPage,
    setPage,
    setPreviousPage,
    totalPages,
    pages,
    setItemsPerPage,
  } = useCustomPagination({
    totalItems,
    initialItemsPerPage,
    initialPage,
  });

  const handleGetNewPageRef = useRef(handleGetNewPage);

  useEffect(() => {
    handleGetNewPageRef.current = handleGetNewPage;
  }, [handleGetNewPage]);

  const handleDebounceGetNewPage = useAsyncDebounce((newPage) => {
    handleGetNewPageRef?.current(newPage);
  }, 200);

  useEffect(() => {
    if (handleGetNewPageRef.current && currentPage >= 0) {
      handleDebounceGetNewPage(currentPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const displayPageLimit = () =>
    pages.slice(
      currentPage >= 3
        ? currentPage >= pages.length - 2
          ? Math.max(0, pages.length - 5)
          : currentPage - 2
        : 0,
      currentPage >= 3 ? currentPage + 3 : 5,
    );

  const handleOnPageChange = (event) => {
    const newPage = event.target.value;

    if ((newPage < 1 && newPage !== "") || newPage === "") return;

    // check if newPage is whole number
    if (newPage % 1 !== 0) return;

    // check if newPage is greater than totalPages
    if (newPage > totalPages) return;

    setPage(newPage - 1);
  };

  const handleOnPageSizeChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    handleGetDataPageSize(Number(event.target.value));

    // reset currentPage to 0
    setPage(0);
    handleGetNewPageRef?.current(0);
  };

  return (
    <div className="common-pagination-container">
      <nav arial-label="Page">
        <ul className="pagination">
          <li className="page-item" onClick={setPreviousPage}>
            <span className="page-link no-copy">Previous</span>
          </li>

          {displayPageLimit().map((valuePage) => (
            <li
              key={valuePage}
              className={
                currentPage === valuePage ? "page-item active" : "page-item"
              }
            >
              <span
                className="page-link no-copy"
                onClick={() => {
                  setPage(valuePage);
                }}
              >
                {valuePage + 1}
              </span>
            </li>
          ))}

          <li className="page-item" onClick={setNextPage}>
            <span className="page-link no-copy">Next</span>
          </li>
        </ul>
      </nav>

      <div className="tw-flex tw-flex-row tw-gap-x-1 tw-items-center">
        <span>
          Page{" "}
          <strong>
            {Math.max(currentPage + 1, 1)} of {Math.max(totalPages, 1)}
          </strong>{" "}
        </span>

        <span>
          | Go to page:{" "}
          <input
            type="number"
            value={Math.max(currentPage + 1, 1)}
            className="tw-w-24"
            onChange={handleOnPageChange}
          />
        </span>

        <select value={initialItemsPerPage} onChange={handleOnPageSizeChange}>
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default CommonPagination;
